import {contentManager} from '../../../api/contentManager';

import ContentPage from '../../../api/contentPageEntity';
import { notifyBreadcrumChangeAction, notifyBreadcrumChangeOnContentPageAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchContentPageByIdAction = (id: string) => (dispatch: any) => {
    dispatch(httpCallStartAction());

    contentManager.fetchContentPageByIdAsync(id)
    .then((contentPageItem) => {
      dispatch(fetchContentPageCompleted(contentPageItem));

      if (contentPageItem.breadcrumbsPath) {
        contentPageItem.breadcrumbsPath.latestPageTitle = contentPageItem.title;
        dispatch(notifyBreadcrumChangeOnContentPageAction(actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE, contentPageItem.breadcrumbsPath));
      } else {
        dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE, contentPageItem.title));
      }

    })
    .catch(error => dispatch(handleError(error)));
};

const fetchContentPageCompleted = (contentPage: ContentPage) => ({
    meta: {
        httpEnd: true,
      },
    payload: contentPage,
    type: actionTypes.FETCH_CONTENT_PAGE_BY_ID_COMPLETED
});

const handleError = (reason: any) => ({
    meta: {
        httpEnd: true,
      },
    payload: {message: reason.message, hasError: true},
    type: actionTypes.FETCH_CONTENT_PAGE_ERROR
});


// WEBPACK FOOTER //
// ./src/components/contentPage/actions/fetchContentPageById.ts